import { CompositeNavigationProp } from '@react-navigation/native'
import { IS_WEB } from 'constants/platform'
import { Share } from 'react-native'

import { generateDynamicLink } from './links'

export const handleShareAction = async (
  url: string,
  message: string,
  navigation: CompositeNavigationProp<any, any>,
  fallbackPage?: string,
  fallbackUsername?: string,
  fallbackStack?: string,
) => {
  const dynamicLink = await generateDynamicLink(url)
  if (IS_WEB) {
    if (navigator.share) {
      await navigator.share({
        title: 'Upspace',
        text: message,
        url: dynamicLink,
      })
    } else if (fallbackStack && fallbackPage) {
      navigation.navigate(fallbackStack, {
        screen: fallbackPage,
        params: {
          username: fallbackUsername,
        },
      })
    } else if (fallbackPage) {
      navigation.navigate(fallbackPage, {
        username: fallbackUsername,
      })
    }
  } else {
    try {
      const result = await Share.share({
        message: `${message} ${dynamicLink}`,
      })
      if (result.action === Share.sharedAction) {
        if (result.activityType) {
          // Link was shared with activity type of result.activityType.
        }
        // Link was shared but no activityType was returned.
      }
      if (result.action === Share.dismissedAction) {
        // Share modal was dismissed.
      }
    } catch (error) {
      console.error(error)
    }
  }
}
